module.exports = __webpack_public_path__ + "img/bar-chart-stacked-dark-01.a0dcf18b.jpg";